export default __webpack_public_path__ + "static/media/hba1c.0cadc7f9.svg";